import { memo } from 'react';
import { Title } from 'src/shared/ui/title/Title';
import cls from './UserInitials.module.scss';

interface IUserInitials {
  onClick: () => void
  text: string
}

export const UserInitials = memo(({ onClick, text }:IUserInitials) => (
  <button
    className={cls.button}
    type='button'
    onClick={onClick}
  >
    <Title>
      {text}
    </Title>
  </button>
));
